<template>
  <div>
    <h1 class="text-xl font-medium leading-6 text-gray-900 mr-2">You're All Set!</h1>
    <p class="mt-6 text-sm text-gray-500">Redirecting to dashboard...</p>
    <LoadingSpinner class="mt-6 flex justify-center" />
  </div>
</template>

<script>
import { useCurrentUserStore } from '@/stores/currentUser.ts';
import { useUserCalendarStore } from '@/stores/userCalendar.ts';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';

export default {
  components: {
    LoadingSpinner,
  },
  setup() {
    const currentUserStore = useCurrentUserStore();
    const userCalendarStore = useUserCalendarStore();
    const loadingSpinnerStore = useLoadingSpinnerStore();
    return { currentUserStore, userCalendarStore, loadingSpinnerStore };
  },
  data() {
    return {
      onboardingCompleted: false,
      calendarCompleted: false,
    };
  },
  watch: {
    calendarCompleted(newValue) {
      if (newValue && !this.onboardingCompleted) {
        this.handleCalendarCompleted();
      }
    },
    onboardingCompleted(newValue) {
      if (newValue) {
        this.loadingSpinnerStore.hideLoadingSpinner();
        this.$router.push('/');
      }
    },
  },
  async mounted() {
    await this.getCalendarAuthStatus();
  },
  methods: {
    async getCalendarAuthStatus() {
      this.loadingSpinnerStore.showLoadingSpinner();
      try {
        await this.currentUserStore.loadCurrentUser();
        this.onboardingCompleted = this.currentUserStore.currentUserAccountDetails.isOnboardingCompleted;

        if (!this.onboardingCompleted) {
          await this.userCalendarStore.loadCalendarAuthStatus(this.currentUserStore.currentUser);
          this.calendarCompleted =
            this.userCalendarStore.currentUserCalendar.isGoogleAuthenticated ||
            this.userCalendarStore.currentUserCalendar.isMicrosoftAuthenticated
              ? true
              : false;
        }
      } catch (error) {
        this.loadingSpinnerStore.hideLoadingSpinner();
      }
    },
    async handleCalendarCompleted() {
      await this.currentUserStore.updateUser({
        user: this.currentUserStore.currentUser,
        updatedUserAttributes: { onboarding_completed: true },
      });
      this.onboardingCompleted = this.currentUserStore.currentUserAccountDetails.isOnboardingCompleted;
    },
  },
};
</script>
